import { Interest } from '../Types/Interest';
import { getApiInstance } from './Api';
import {
  generateAssetRenditionUrl,
  ImageFormat,
  INTEREST_IMAGE_RENDITIONS,
} from '../Utils/Assets';

const mapInterest = (interest: any): Interest => ({
  id: interest.id,
  name: interest.name,
  parentInterest: interest.parentInterest,
  childInterests: interest.childInterests.map(mapInterest),
  image: interest.imageUrl && {
    originalUrl: interest.imageUrl,
    compressedUrl: generateAssetRenditionUrl(
      interest.imageUrl,
      null,
      ImageFormat.WEBP,
    ),
    thumbnailUrl: generateAssetRenditionUrl(
      interest.imageUrl,
      INTEREST_IMAGE_RENDITIONS.THUMBNAIL,
      ImageFormat.WEBP,
    ),
  },
});

export const fetchInterests = async () => {
  try {
    const response = await getApiInstance().get(`/interests`);
    const interests: Interest[] = response.data.map(mapInterest);
    return interests;
  } catch (error) {
    console.error('Error fetching interests', error);
    throw error;
  }
};
export const fetchLeafInterests = async () => {
  try {
    const response = await getApiInstance().get(`/interests/leaf`);
    const interests: Interest[] = response.data.map(mapInterest);
    return interests;
  } catch (error) {
    console.error('Error fetching interests', error);
    throw error;
  }
};

export const trackInterest = async (userId: string, interest: Interest) => {
  try {
    await getApiInstance().post(`/interests/${userId}/${interest.id}`);
  } catch (error) {
    console.error('Error tracking interest', error);
    throw error;
  }
};
